import { Box, Container, Typography } from '@mui/material';
import splash from '../assets/splash.png';

const HomePage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box textAlign="center" mt={6}>
        <Typography variant="h2" color="primary" gutterBottom>
          Welcome to Street Ratings
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Discover and find Google reviews at your fingertips!
        </Typography>
        <br />
        <Box
          component="img"
          src={splash}
          sx={{
            width: '100%',
            maxHeight: 400,
            objectFit: 'cover',
            borderRadius: 2,
          }}
        />
      </Box>
    </Container>
  );
};

export { HomePage };
